import React from "react";
import formatDate from "../../../../../../gd/format/date";
import DatetimeUtils from "../../../../../../gd/utils/datetime-utils";

export default function FieldDate_FormValueNotEmpty(props:any) {

    const showIcon = _.get(props.options, 'showIcon', true)

    return (
        <React.Fragment>
            <div className={Classes("ui5-txt-default ui5-field-form-editable dropdown-form h-36", props.className)} onClick={props.onClick}>
                {showIcon && _.get(props.field.components, 'ValueIcon', false)}
                <span>{props.value && formatDate(DatetimeUtils.dateToMoment(props.value))}</span>
            </div>
            {props.children}
        </React.Fragment>
    );
}
